// Functions defined in this file
// async checkLoginStatus (from, to, token, email, password)
// processLogout()
// async refreshLogin ()
// import '../../../coreui/mixins/logMixin'

import axiosInstances from "@/../../coreui/server/axiosInstances.js";
import axios from "axios";
import jwt_decode from "jwt-decode";
import cache from "@/../../coreui/helpers/cache";
import loginStore from "@/../../coreui/store/login.js";
import store from "../store/index";
import utils from "./utils.js";

export default {
  methods: {
    async checkLoginStatus(from, to) {
      let tokenValid = false;
      let decoded,
        d = new Date(0);
      let token = to.query["orgToken"] || to.query["token"];
      let email = to.query["email"];
      let password = to.query["password"];
      if (to.query["facility"] != null) {
        localStorage.setItem("facility", to.query["facility"]);
      }
      if (to.query['facilityToken'] != null) {
        let facilityDecoded
        try {
          facilityDecoded = jwt_decode(to.query['facilityToken'])
          console.log('decoded facility token: ', facilityDecoded)
        } catch (e) {
          console.log(e)
          return false
        }
        localStorage.setItem('facilityToken', to.query['facilityToken'])
        // localStorage.setItem('facility', facilityDecoded['aud'])
        loginStore.state.facilityToken = to.query['facilityToken']
        loginStore.state.facility = facilityDecoded['aud']
      }
      if (to.query["kiosk"] != null) {
        localStorage.setItem("kiosk", "yes");
      }
      if (!email) {
        if (!token) {
          token = localStorage.getItem("origToken");
        }
        if (localStorage.getItem("continue") && !token) {
          return false;
        }
        // if (!token) {
        //   token = localStorage.getItem('origToken')
        // }

        if (!token) {
          return false;
        }
        try {
          decoded = jwt_decode(token);
        } catch (e) {
          console.log(e);
          return false;
        }
        d.setUTCSeconds(decoded["exp"]);
        if (Date.now() > d) {
          console.log("Login Time Expired");
          return false;
        } else {
          let header = {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          };
          let u = await axios.get(
            "https://auth.entrinsia.net/dt/v1/users/" + decoded["sub"],
            {
              headers: header,
            }
          );
          if (u != null && u.data) {
            let d = u.data;
            delete d.password;
            d.uid = d._id;
            d["x-access-token"] = token;
            loginStore.state.loggedinUser = d;
            loginStore.state.origLoggedinUser = d;
            // loginStore.state.initialLoginComplete = true
          }
          return true;
        }
      }
      if (email && password) {
        let res, data;
        try {
          res = await axiosInstances.loginServer.post("/auth/login", {
            email: email,
            password: password,
          });
          data = res.data;
        } catch (ex) {
          loginStore.state.loginError = ex.message;
          loginStore.state.loginFailed = true;
          return false;
        }
        if (data) {
          loginStore.state.loggedinUser = data;
          loginStore.state.origLoggedinUser = data;
          loginStore.state.initialLoginComplete = true;
          tokenValid = true;
          return true;
        }
      }
      return false;
    },

    processLogout() {
      // reverse everything you did while logging in
      this.loginMenuItems = [];
      this.kiosk = false;
      this.allowed_facilities = null;
      this.error_metrc = null;
      this.error_state = null;
      this.current_org = null;
      this.initial_facility = null;
      this.endMQTT();
      localStorage.removeItem("origToken");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("origRefreshToken");
      localStorage.removeItem("loggedIn");
      this.loggedIn = false;
      loginStore.state.initialLoginComplete = false;
      cache.reset();
      this.loginDialog = true;
      // window.location.href = "https://cortex.entrinsia.com"
    },

    async checkMETRCCredentials() {
      this.elog("trace", "Checking METRC credentials")();
      if (this.origLoggedinUser.role == "super") {
        // don't check for METRC creds for super
        this.elog(
          "trace",
          "Not checking METRC credentials, role is {}",
          this.origLoggedinUser.role
        )();
        // loginStore.state.initialLoginComplete = true
        return true;
      }
      let res;
      if (this.origLoggedinOrg.name != "lobby") {
        // no need to get METRC data
        this.elog(
          "trace",
          "Not checking METRC credentials, org is {}",
          this.origLoggedinOrg.name
        )();
        // loginStore.state.initialLoginComplete = true
        return true;
      }
      // let noCreds = false
      try {
        res = await axiosInstances.origApiServer.get(
          "dt/v1/temp_processing?email=" + this.origLoggedinUser.email
        );
        this.elog(
          "trace",
          "METRC creds check - temp_processing entry: {}",
          res
        )();
        if (res != null && res.data != null && res.data.length != 0) {
          // this account is being processed
          this.elog("trace", "temp_processing entry: {}", res.data)();
          if (
            res.data[0]["error_lic"] != "yes" &&
            res.data[0]["error_metrc"] != "yes"
          ) {
            this.elog(
              "trace",
              "Normal processing, error_lic {}, error_metrc {}",
              res.data[0]["error_lic"],
              res.data[0]["error_metrc"]
            )();
            this.$refs.confirm.open(
              "Info",
              "Your account is being processed. You will receive an email when your account is ready for access.",
              {
                nocancel: true,
                ok: "OK",
                width: 480,
                color: "green",
              }
            );
            return;
          } else {
            // there was an error in processing credentials
            this.elog("trace", "METRC check results: {}", res.data)();
            this.metrc_key = res.data[0]["metrc_api"];
            this.state_license = res.data[0]["lic"];
            this.error_state = res.data[0]["error_lic"] == "yes" ? true : false;
            this.error_metrc =
              res.data[0]["error_metrc"] == "yes" ? true : false;
            this.err_found = true;
            this.state = res.data[0]["state"];
            // noCreds = true
          }
          // return false
        }
      } catch (ex) {
        this.elog("error", ex)();
      }

      // if (noCreds ) {
      var stat = await this.$refs.metrccreds.open(
        "Add your METRC API Key and State License Number",
        "",
        {
          width: 800,
          html: true,
          ok: "Submit",
          cancel: "Cancel",
          err_state: this.error_state,
          err_metrc: this.error_metrc,
          metrc: this.metrc_key,
          license: this.state_license,
          state: this.state,
        }
      );
      if (stat) {
        this.$refs.confirm.open(
          "Please wait for authorization email",
          "You will receive an email when Cortex has verified your credentials and retrieved data from METRC",
          {
            width: 500,
            html: false,
            ok: "OK",
            nocancel: true,
            err_state: this.error_state,
            err_metrc: this.error_metrc,
            metrc: this.metrc_key,
            license: this.state_license,
            state: this.state,
          }
        );
      } else {
        this.$refs.confirm.open(
          "No METRC Credentials Provided",
          "You need to provide your METRC API Key and State License ID to use Cortex",
          {
            width: 500,
            html: false,
            ok: "OK",
            nocancel: true,
          }
        );
      }
      return false;
      // } else {
      //   return true
      // }
    },

    async checkEULAAndMETRC() {
      // this.elog('log', 'Checking EULA and METRC Creds {}', loginStore.state.origLoggedinUser.email)()
      var x = await axiosInstances.loginServer.get(
        "/dt/v1/users?email=" + loginStore.state.origLoggedinUser.email
      );
      var y = await axiosInstances.origApiServer.get(
        "/dt/v1/temp_eula?email=" + this.origLoggedinUser.email
      );
      console.log("***** ", x, y);
      if (x != null && x.data != null) {
        x = x.data[0];
      } else {
        x = null;
      }
      if (y != null && y.data != null) {
        y = y.data[0];
      } else {
        y = null;
      }
      if (
        x != null &&
        (x["eulaip"] == undefined ||
          x["eulaip"] == null ||
          x["eulaip"] == "") &&
        (y == null || y["status"] != "accepted")
      ) {
        loginStore.state.loader.hide();
        // this.elog('debug','eula nopt accepted yet')()
        var eula = await import("!raw-loader!@/assets/eula.html");
        var stat = await this.$refs.confirm.open(
          "Terms of Service and EULA",
          eula.default,
          { width: 800, html: true, ok: "Agree", cancel: "Disagree" }
        );
        if (!stat) {
          axiosInstances.origApiServer.post("/dt/v1/temp_eula", {
            email: this.loggedinUser.email,
            status: "declined",
          });
          this.logout();
        } else {
          axiosInstances.origApiServer.post("/dt/v1/temp_eula", {
            email: this.loggedinUser.email,
            status: "accepted",
          });
          this.elog("debug", "checking METRC credentials")();
          this.loggedIn = await this.checkMETRCCredentials();
        }
      } else {
        this.loggedIn = await this.checkMETRCCredentials();
        localStorage.setItem("loggedIn", this.loggedIn);
      }
      if (!this.loggedIn) {
        this.logout();
        localStorage.setItem("loggedIn", false);
        return false;
      }
      return true;
    },

    async refreshLogin() {
      this.elog("trace", "In refreshLogin")();
      let data;
      try {
        let res = await axiosInstances.loginServer.post("/auth/refresh", {
          "refresh-token": localStorage.getItem("refreshToken"),
        });
        data = res.data;
        loginStore.state.loggedinUser = data;
      } catch (ex) {
        console.log(ex);
        this.$store.state.loginFailed = true;
        return;
      }
      localStorage.setItem("token", data["x-access-token"]);
      localStorage.setItem("refreshToken", data["refresh-token"]);
      this.initMQTT(this.loggedinUser.org, this.loggedinUser.uid);
    },

    async setOrigUser() {
      this.elog("trace", "In setOrigUser")();
      let origOrg, user, origUser;
      user = loginStore.state.origLoggedinUser;
      localStorage.setItem("origToken", user["x-access-token"]);
      localStorage.setItem("origRefreshToken", user["refresh-token"]);
      localStorage.setItem("token", user["x-access-token"]);
      localStorage.setItem("refreshToken", user["refresh-token"]);
      try {
        origUser = await axiosInstances.loginServer.get(
          "/dt/v1/users/" + user.uid
        );
        origOrg = await axiosInstances.loginServer.get(
          "/dt/v1/org?name=" + user.org
        );
        // if (origOrg.data[0].type.includes('Free')) return false
      } catch (ex) {
        console.log("ex: ", ex);
        this.elog("error", "Error in fetching org for user {}", user.email)();
        return false;
      }
      loginStore.state.origLoggedinUser = {
        ...loginStore.state.origLoggedinUser,
        ...origUser.data,
      };
      if (
        origOrg &&
        origOrg.data &&
        origOrg.data.length === 1 &&
        origOrg.data[0].server !== undefined
      ) {
        axiosInstances.origApiServer.defaults.baseURL = origOrg.data[0].server;
        if (origOrg.data[0].compserver)
          axiosInstances.computeServer.defaults.baseURL =
            origOrg.data[0].compserver;
        if (origOrg.data[0].fileserver) {
          axiosInstances.fileServer.defaults.baseURL =
            origOrg.data[0].fileserver;
        } else {
          // leave it at default
        }
        loginStore.state.origLoggedinOrg = origOrg.data[0];
      } else {
        loginStore.state.loggedIn = false;
      }
      return true;
    },

    async parentLogin() {
      // this.elog('trace', 'Login succeeded, post processing login')()
      // set debugging if logged in as super
      // if (loginStore.state.origLoggedinUser.role == 'super') {
      //   window.loggerFactory.setLogWarnings(1)
      // } else {
      //   window.loggerFactory.setLogWarnings(1)
      // }
      // setup original, parent, login org and tokens
      if (!(await this.setOrigUser())) {
        this.elog("debug", "setOrigUser failed");
        return false;
      }

      // process initial housekeeping
      let pref = await axiosInstances.loginServer.get("/dt/v1/auth_phrasemap");
      console.log("header: ", axiosInstances.loginServer.headers);
      this.elog("debug", "Loading Phrase map")();
      if (pref && pref.data) {
        // this.$store.state.misc.phraseMap = pref.data
        store.state.misc.phraseMap = pref.data;
        this.elog("debug", "Phrase map loaded")();
      }
      pref = await axiosInstances.loginServer.get("/dt/v1/dictionary");
      if (pref && pref.data) {
        // this.$store.state.table.dictionary = pref.data
        store.state.table.dictionary = pref.data;
        // this.elog('debug', 'Dictionary loaded')()
      }
      let sensors = await axiosInstances.loginServer.get(
        "/dt/v1/auth_provisions?org=" + loginStore.state.origLoggedinUser.org
      );
      if (sensors && sensors.data) {
        // this.$store.state.table.orgSensors = sensors.data
        store.state.table.orgSensors = sensors.data;
      }
      cache.preloadLogin(["set_usstate", "set_cannabis", "auth_bot_msg"]);

      this.elog(
        "trace",
        "Original logged in user and org {} {}",
        this.origLoggedinUser,
        this.origLoggedinOrg
      )();
      if (this.origLoggedinUser.org == "lobby") {
        loginStore.state.loader.hide();
      }
      // complete EULA and METRC credentials checking
      if (!loginStore.state.fullScreen) {
        let eulaok = await this.checkEULAAndMETRC();
        if (!eulaok) {
          this.elog("error", "EULA not accepted")();
          return;
        }
        console.log("CHECKPOINT");
        // set initial facility, after first checking if anything is saved
        let savedFac = await this.getUserPreference("facility");
        let fcty = localStorage.getItem("facility");
        if (fcty != null) {
          this.elog("Set facility based on localStorage {}", fcty)();
          this.initial_facility = fcty;
          localStorage.removeItem("facility");
        } else if (savedFac != null) {
          this.initial_facility = savedFac;
          this.elog(
            "trace",
            "Initial facility set to {} based on saved preference",
            this.initial_facility
          )();
        } else {
          this.initial_facility = this.origLoggedinOrg.name;
        }
      } else {
        this.initial_facility = loginStore.state.facility
      }
      this.initOrigMQTT();
      return true;
    },

    async getFullnameFromCode(code) {
      let res = await axiosInstances.loginServer.get(
        "/dt/v1/org?name=" + code + "&return=fullName"
      );
      let fname;
      if (res != null && res.data != null && res.data[0] != null) {
        fname = res.data[0]["fullName"] ? res.data[0]["fullName"] : code;
      } else {
        fname = code;
      }
      return fname;
    },

    async setFacilityCreds(facility) {
      this.elog("trace", "In setFacilityCreds {}", facility)();
      let res;
      let org, facUser, switchedUser;
      try {
        res = await axiosInstances.loginServer.get(
          "/misc/switchorg?org=" + facility
        );
      } catch (e) {
        this.elog("error", e)();
        res = await axiosInstances.loginServer.get(
          "/misc/switchorg?org=" + this.origLoggedinOrg.name
        );
      }
      console.log("RES: ", res, this.origLoggedinOrg.name);
      if (!res || !res.data) {
        res = await axiosInstances.loginServer.get(
          "/misc/switchorg?org=" + this.origLoggedinOrg.name
        );
        facility = this.origLoggedinOrg.name;
      }
      if (res == null || res.data == null || res.data.length == 0) return;
      switchedUser = res.data;
      localStorage.setItem("token", switchedUser["x-access-token"]);
      localStorage.setItem("refreshToken", switchedUser["refresh-token"]);

      let facs = [];
      let facList = [];
      let oUser = loginStore.state.origLoggedinUser;
      org = await axiosInstances.loginServer.get("/dt/v1/org?name=" + facility);
      loginStore.state.loggedinOrg = org.data[0];
      if (
        org &&
        org.data &&
        org.data.length === 1 &&
        org.data[0].server !== undefined
      ) {
        axiosInstances.apiServer.defaults.baseURL = org.data[0].server;
        if (org.data[0].compserver)
          axiosInstances.computeServer.defaults.baseURL =
            org.data[0].compserver;
      }
      if (oUser.role == "super") {
        let orgs = await axiosInstances.loginServer.get("/dt/v1/org");
        orgs.data.forEach((i) => {
          // facList.push(i['name']);
          facs.push({
            code: i["name"],
            name: i["fullName"] ? i["fullName"] : i["name"],
          });
        });
      } else {
        let fs = oUser.props.facilities;
        for (var f in oUser.props.facilities) {
          facs.push({
            code: fs[f],
            name: await this.getFullnameFromCode(fs[f]),
          });
        }
      }
      loginStore.state.loggedinUser.facilities = facList;
      let modules = [];
      if (oUser.role != "super") {
        oUser.props["modules"].forEach((i) => {
          if (i[this.current_org] != null)
            i[this.current_org].forEach((m) => {
              modules.push(m);
            });
        });
      } else {
        // all modules
        modules = null;
      }
      this.loginMenuItems = await this.buildMainMenu(modules);
      await this.buildRoutes(modules);
      this.menuIsBuilt = true;
      loginStore.state.loggedinUser = { ...switchedUser, ...facUser };
      this.allowed_facilities = facs;
      // save this facility to preferences so next login will set facility to this
      await this.setUserPreference("facility", facility);
      // reset facility MQTT
      this.endFacMQTT();
      this.initFacMQTT();
      loginStore.state.loggedIn = true;
    },
  },
};
